let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5bLPT")).then(() => parcelRequire('5Mgi1'));